// @flow

import React, { type Node } from 'react';
import {
  getCountry,
  getRedirectUrl,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { useRedirect } from '@tectonics/hooks';
import { Link, Separator } from '@tectonics/look-and-feel/uber-v2/atoms';
import type { Country } from '@tectonics/prs/country';

export function PixPispPendingPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const voucherUrl = getRedirectUrl(incomingPayment);

  useRedirect(voucherUrl, 1000);

  return (
    <div data-test-id="page-pending-payment">
      <Separator direction="vertical" size={4} />
      {getCountryBasedLabelMessage(country, voucherUrl)}
    </div>
  );
}

function getCountryBasedLabelMessage(country: Country, voucherUrl: string): Node {
  switch (country) {
    case 'br':
      return <p>Você está sendo redirecionado para as instruções de pagamento, se isso não acontecer, <Link
        href={voucherUrl}>clique aqui</Link>.</p>;
    default:
      throw new Error(`No redirect-page-content found for country ${country}`);
  }
}
